import React from 'react';
import TabBadge from '../components/shared/TabBadge';
import { useSuper } from './SupervisorAvailability';

/**
 * Tab placeholders for the supervisor pages — the `placeholder` on an InnerTabsd /
 * InnerTabsm entry. Each reads the shared SupervisorProvider, so the number is the
 * same one the tab itself shows. Nothing renders until that list has loaded.
 *
 *   Create Jobs / Jobs   every job not Closed (the pipeline)
 *   Open Slots / Slots   open availability days on the board = the "All" chip
 *   Responses / Replies  accepted jobs waiting for Approve
 *   Messages             bell, unread job messages
 */
export const JobsCountBadge = () => {
  const s = useSuper();
  if (!s || (s.snlJobsLoading && s.snlJobs.length === 0)) return null;
  return <TabBadge title="Jobs in the pipeline">{s.snlJobs.filter((j) => j.status !== 'Closed').length}</TabBadge>;
};

export const OpenSlotsBadge = () => {
  const s = useSuper();
  if (!s || (s.slotsLoading && s.slots.length === 0)) return null;
  return <TabBadge title="Open availability days">{(s.openSlots || []).length}</TabBadge>;
};

export const ToApproveBadge = () => {
  const s = useSuper();
  if (!s || (s.responsesLoading && s.responses.length === 0)) return null;
  return <TabBadge title="Accepted — waiting for Approve">{s.awaitingApproval}</TabBadge>;
};

export const MessagesBellBadge = () => {
  const s = useSuper();
  if (!s) return null;
  return <TabBadge bell unread={s.unreadTotal} />;
};
